/**
 * Constants for Heartbeat events
 *
 * @namespace constants.heartbeatEvents
 */
export default {
  failed: 'failed'
};
